import React from 'react';
import { Route } from 'react-router-dom';

import { RoutePathProps } from '../../../AppRoutes/types';
import QuizIcon from '@mui/icons-material/Quiz';
import ListEnquiry from '../pages/ListEnquiry';
import ShowEnquiry from '../pages/ShowEnquiry';
import CreateEditEnquiry from '../pages/CreateEditEnquiry';


// import EditProduct from '../pages/EditProduct';

const enquiry: RoutePathProps = {
  name: "enquiry",
  path: "/enquiry",
  label: "Enquiry",
  icon: QuizIcon,
  visibleInNav: true,
  requiredPermission:'enquiry:list',
  children: [
    {
      name: "showEnquiry",
      path: "/enquiry/:id",
      label: "Show Enquiry",
      icon: QuizIcon,
      requiredPermission:'enquiry:read'
    },
    {
      name: "createEnquiry",
      path: "/enquiry/createEnquiry",
      label: "Create Enquiry",
      icon: QuizIcon,
      requiredPermission:'enquiry:create'
    },
    {
      name: "editEnquiry",
      path: "/enquiry/editEnquiry/:id",
      label: "Edit Enquiry",
      icon: QuizIcon,
      requiredPermission:'enquiry:update'
    },
    {
      name: "listEnquiry",
      path: "/enquiry/listEnquiry",
      label: "List Enquiry",
      icon: QuizIcon,
      requiredPermission:'enquiry:list'
    }
  ],
};

const EnquiryRoutes = (
  <>
    <Route path={enquiry.path} element={<ListEnquiry />} />
    <Route path={enquiry.children?.[0].path} element={<ShowEnquiry />} />
    <Route path={enquiry.children?.[1].path} element={<CreateEditEnquiry />} />
    <Route path={enquiry.children?.[2].path} element={<CreateEditEnquiry />} />
    {/* <Route path={enquiry.children?.[2].path} element={<AddProduct />} /> */}
    <Route path={enquiry.children?.[3].path} element={<ListEnquiry />} />

  </>
);
export const enquiryPaths = [enquiry];
export default EnquiryRoutes;
